import { Button, CircularProgress, Stack, Typography } from '@mui/material';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import PauseIcon from '@mui/icons-material/Pause';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import DashboardWidgetCard from '../../Dashboard/DashboardWidgetCard';

const busySpinner = <CircularProgress size={16} color='inherit' />;

// Widget 1 — quick actions for the selected flow. Mutating actions are hidden
// when the user lacks the corresponding right; the parent view owns the handlers.
export default function QuickActionsWidget({
  flow,
  canUpdate,
  canActivate,
  busy,
  onEditFlow,
  onToggleFlow,
  loading,
  error,
  onRetry,
}) {
  const flowActive = flow?.status === 'active';
  const hasAnyAction = canUpdate || (canActivate && flow);

  return (
    <DashboardWidgetCard
      title='Schnellaktionen'
      icon='Bolt'
      accent='primary'
      loading={loading}
      error={error}
      onRetry={onRetry}
    >
      <Stack spacing={1} sx={{ flexGrow: 1 }} justifyContent='center'>
        {canUpdate && (
          <Button
            variant='outlined'
            size='small'
            startIcon={<AccountTreeIcon />}
            disabled={Boolean(busy) || !flow}
            onClick={onEditFlow}
          >
            Flow bearbeiten
          </Button>
        )}
        {canActivate && flow && (
          <Button
            variant='contained'
            size='small'
            color={flowActive ? 'warning' : 'success'}
            startIcon={busy === 'toggle' ? busySpinner : flowActive ? <PauseIcon /> : <PlayArrowIcon />}
            disabled={Boolean(busy)}
            onClick={onToggleFlow}
          >
            {flowActive ? 'Flow pausieren' : 'Flow aktivieren'}
          </Button>
        )}
        {!hasAnyAction && (
          <Typography variant='body2' color='text.secondary'>
            Keine Aktionen verfügbar – dafür fehlen dir die nötigen Berechtigungen.
          </Typography>
        )}
      </Stack>
    </DashboardWidgetCard>
  );
}
